export { default } from './List';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/List/index.js
// module id = 142
// module chunks = 0